var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 83,
    viewBox: "0 0 97 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4333 28.2862C-11.1208 14.3809 4.30975 -6.77777 32.1907 2.59906C53.805 9.86833 60.9863 16.8491 73.8155 22.5046C80.5012 25.4518 99.3381 34.8558 96.5197 44.2112C92.1506 58.714 64.892 45.926 61.9867 43.0218C51.286 32.3247 40.9468 50.515 28.0196 76.1822C23.8889 84.384 12.016 83.7354 6.24046 78.8964C-5.11944 69.3787 3.3284 56.2415 17.8296 44.0504C20.3063 41.9683 41.1242 28.2862 32.4333 28.2862V28.2862Z",
    fill: "#FF0066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43954 6.5901C4.22896 9.41283 7.20543 14.8885 9.57168 16.9103C10.188 17.437 17.1384 22.9244 26.4318 26.5314C27.6402 27.0004 32.7851 28.2082 33.5914 29.0103C34.5121 29.9263 30.8629 34.1127 30.9317 34.1119C32.6634 34.0951 38.262 27.499 34.8585 24.6594C30.423 20.9589 24.328 21.1599 20.599 19.1689C14.1526 15.7268 6.04701 10.7562 5.43954 6.5901V6.5901Z",
    fill: "#C42062"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04838 56.1683C3.296 60.4439 -0.270553 65.6276 0.895969 71.2537C2.80414 80.4556 13.955 84.7441 22.5567 81.3322C26.7687 79.6614 29.4924 74.5839 30.9406 70.7223C31.4676 69.3167 37.7688 57.2608 40.7292 53.2099C42.0696 51.376 46.1281 45.4228 45.9882 45.6327C45.6504 46.1394 40.5492 51.0975 38.2984 53.3484C34.6057 57.041 28.1048 60.3963 28.0714 65.6264C28.0313 71.9347 17.2273 77.2746 12.8997 76.1703C2.58913 73.5395 0.647171 64.5132 6.04838 56.1683V56.1683Z",
    fill: "#C42062"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0261 40.3216C71.9131 45.8904 73.0974 42.5918 75.8296 44.8377C77.6154 46.3058 80.3876 45.0098 82.3189 46.32C90.9159 52.152 96.5673 38.119 94.3957 36.1219C94.3957 36.1219 97.1728 39.0428 96.7335 43.8044C96.2567 48.9756 92.3012 51.0807 87.2802 51.3125C80.2048 51.6392 68.9409 47.1757 65.0454 45.3677C61.4825 43.7141 62.5827 42.2968 58.0261 40.3216V40.3216Z",
    fill: "#C42062"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0623 11.1226C29.397 10.6497 34.7828 15.3437 30.8828 14.2435C13.6 9.36856 8.23893 0.299023 24.0637 3.62726C33.0392 5.51487 60.0348 20.2202 60.8891 21.3592C62.3518 23.3095 61.6513 25.2323 59.3704 25.5698C55.4493 26.1502 51.8231 23.9443 48.912 27.6163C46.5357 30.614 37.1885 41.6195 34.5142 43.7026C33.2574 44.6816 30.1608 46.2694 27.9973 46.6684C24.9352 47.2332 27.4829 41.5067 30.6226 41.2269C33.4088 40.9785 43.4205 30.6195 43.9624 25.1228C44.6635 18.0099 36.4342 12.6484 31.0623 11.1226V11.1226Z",
    fill: "#FF3D8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.171 65.84C12.8951 70.1717 18.9599 52.7905 21.6527 51.5779C16.2742 51.2754 7.60183 61.7545 10.171 65.84V65.84Z",
    fill: "#FF3D8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7455 26.8514C69.0751 25.6437 73.7483 28.9451 74.2752 29.462C77.2153 32.3474 85.4461 36.9005 84.8489 37.8067C84.5529 38.2557 72.4148 36.242 69.6421 32.3634C67.9995 30.0656 63.2334 27.7626 65.7455 26.8514Z",
    fill: "#FF3D8B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8877 9.17273C25.6467 9.37192 20.5743 1.26022 38.41 10.6141C55.6825 19.6726 55.0182 19.6161 54.1678 21.475C52.7632 24.546 54.5322 16.6191 50.1244 23.2407C46.0417 29.3739 42.4064 32.8008 43.9013 30.0583C46.0261 26.1605 49.3263 23.7684 48.6644 20.5182C47.8011 16.2778 33.8747 8.15283 29.0429 8.31745C26.9357 8.38918 30.3527 12.9586 25.8877 9.17273V9.17273Z",
    fill: "#FF73AB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0635 28.5459C69.2235 28.6714 82.4862 34.3781 80.0516 35.9885C77.6172 37.5991 79.5009 33.4037 75.8654 33.0523C72.2298 32.701 68.3926 28.0203 69.0635 28.5459V28.5459Z",
    fill: "#FF73AB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5141 53.2476C18.7643 52.687 8.42985 61.8087 12.7754 60.9255C16.2787 60.2137 16.5406 57.9544 17.6846 55.6832C18.4025 54.258 19.9032 53.5385 19.5141 53.2476Z",
    fill: "#FF73AB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT2);
export default __webpack_public_path__ + "static/media/T2.33ef3b121be51ce5d2cd95169b0a4e98.svg";
export { ForwardRef as ReactComponent };